import React, { InputHTMLAttributes } from "react";

export interface SwitchProps extends InputHTMLAttributes<HTMLInputElement> {

}

export function Switch(props: SwitchProps) {
    return <input className="component-switch" type="checkbox" {...props}/>
}